import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { getConsumptionsSummary } from '../../../../slices/thunks';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { createSelector } from 'reselect';
import { Card, CardFooter, CardHeader, CardBody } from 'reactstrap';
import EChartsDoughnutChart from '../../../../Components/Common/Charts/ECharts/EChartsDoughnutChart';
import { ECHARTS_COLOR_PALETTE } from '../../../../Components/Hooks/useColorArrayHooks';

const ResidueDonutEChart = ({
    establishmentId,
    colors,
    chartData,
    title,
    subtitle,
    option,
    legendPosition,
    height,
    with_total = true,
    um = '',
}) => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState(option);

    // Memoized selector with shallow equality check
    const selectorFuelSupply = useMemo(
        () =>
            createSelector(
                state => state.FuelSupply,
                data => ({
                    data: data.fuelSupplySummary,
                    loading_tank: data.isLoadingList,
                })
            ),
        []
    );

    const data = ['data'];

    // Memoized dispatch function to prevent unnecessary re-executions
    const fetchConsumptionData = useCallback(
        (establishment_id, filter) => {
            if (establishment_id) {
                dispatch(
                    getConsumptionsSummary({
                        establishment_id,
                        filter,
                    })
                );
            }
        },
        [dispatch]
    );

    useEffect(() => {
        fetchConsumptionData(establishmentId, selectedFilter);
    }, [establishmentId, selectedFilter, fetchConsumptionData]);

    // const chartData = useMemo(() => {
    // 	if (!data) return [];
    // 	return data.map(item => ({
    // 		value: item.total_amount,
    // 		name: `${item.fuel_type} (${item.unit_measurement})`,
    // 	}));
    // }, [data]);


    // Memoized chart options
    const options = useMemo(
        () => ({
            color: colors,
            tooltip: {
                trigger: 'item',
            },
            legend: {
                orient: 'horizontal',
                bottom: 0,
                type: 'scroll',
            },
            series: [
                {
                    name: 'Consumo',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'outside',
                        formatter: '{d}%'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '20',
                            fontWeight: 'bold',
                        },
                    },
                    labelLine: {
                        show: false,
                    },
                    data: chartData,
                },
            ],
        }),
        [chartData]
    );

    if (data.length === 0) {
        return (
            <Card className='h-100 p-0 mb-2'>
                <CardHeader className='p-2 align-items-center d-flex'>
                    <h5 className='flex-grow-1 m-0'>{title}</h5>
                </CardHeader>
                <CardBody className='p-2'>
                    <div className='d-flex justify-content-center align-items-center p-3'>
                        <div className='text-center'>
                            <div className='avatar-md'>
                                <span className='avatar-title bg-info-subtle rounded-circle fs-1'>
                                    <i className='ri-gas-station-fill text-info'></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </CardBody>
                <CardFooter className='m-0 p-2 text-center'>
                    <h6 className='mb-0 p-0 text-wrap w-100'>
                        <span className='fs-11 badge bg-info-subtle text-info text-wrap'>
                            No cuenta con registro de consumo de combustible
                        </span>
                    </h6>
                </CardFooter>
            </Card>
        );
    }

    return (
        <Card className='h-100'>
            <CardHeader className='p-2 align-items-center d-flex'>
                <h5 className='card-title mb-0 flex-grow-1'>{title}</h5>
            </CardHeader>
            <CardBody className='p-0'>
                <EChartsDoughnutChart
                    options={options}
                    style={{ height: height }}
                />
            </CardBody>
        </Card>
    );
};

export default ResidueDonutEChart;
